import styled from "styled-components";

export const Input = styled.input`
  background: #fff;
  border-radius: 100px;
  padding: 10px 10px 10px 15px;
  border: none;
  width: 100%;
  font-size: 1rem;
  outline: none;
`;
